// extracted by mini-css-extract-plugin
export default {"item_wrapper":"product-cards-form_item_wrapper__wgvFc","items_container":"product-cards-form_items_container__PnMK7"};